import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
  title?: string;
  className?: string;
};

const FluxLogoDark = () => (
  <div className="auth-logo">
    <span className="auth-logo__light">flux</span>
    <span className="auth-logo__medium">prompt</span>
    <span className="auth-logo__dot" />
  </div>
);

const AuthCard = ({ children, className }: Props) => {
  return (
    <div className={`auth-card${className ? ` ${className}` : ''}`}>
      <div className="auth-card__header">
        <FluxLogoDark />
      </div>
      <div className="auth-card__body">{children}</div>
      <div className="auth-card__footer">
        <Link to="/legal/terms-of-service">Terms of Service</Link>
        <Link to="/legal/privacy-policy">Privacy Policy</Link>
      </div>
    </div>
  );
};

export default AuthCard;
